import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react";
import { BasicContext } from '../../context/BasicContext'
import WebServiceContext  from '../../webService/WebServiceContext'

export default () => {
    const bc = useContext(BasicContext)
    const setCurrentPage = (PID:string)=>{
        bc.setPID(PID)
    }


    const ws = useContext(WebServiceContext)
  

    const loadMenuContent = (GID:string) =>{
        
    }

    const MenuButton = (props:MenuButtonProps)=>
        <button 
            className={"hibBtn "+(props.BID == bc.PID ? "active":"main")}
            onClick={()=>{
                if(props.BID){
                    setCurrentPage(props.BID)
                }
                //console.log(props)
            }}>
            {props.txt} 
        </button>

    return(
        < >
        
        {
            bc.menuData.map(
                (item:MenuButtonProps, index:number)=>{
                    return(
                        <MenuButton 
                            key={"mBtn"+index}
                            BID={item.BID}
                            txt={item.txt}
                            TabName={item.TabName}
                            TabOrd={item.TabOrd}
                        />    
                    )
                }
            )
        }
        </>
    )
}